import React, {useEffect, useState} from "react";
import axios from "axios";
import "../styles/QuestionForm.css";

export default function QuestionForm() {
    const [groups, setGroups] = useState([]);
    const [form, setForm] = useState({
        question: "",
        correctAnswer: "",
        op_1: "",
        op_2: "",
        op_3: "",
        op_4: "",
        op_5: "",
        groupId: ""
    });

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/question-groups`).then((res) => setGroups(res.data));
    }, []);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setForm({...form, [name]: value});
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            ...form,
            group: {id: form.groupId}
        };
        delete payload.groupId;

        axios.post(`${process.env.REACT_APP_API_URL}/questions`, payload)
            .then(() => alert("Soru başarıyla eklendi!"))
            .catch((err) => alert("Hata: " + err.message));
    };

    return (
        <form onSubmit={handleSubmit} className="question-form">
            <h2>Yeni Soru Ekle</h2>
            <label htmlFor="question">Soru Metni</label>
            <textarea name="question" value={form.question} onChange={handleChange} placeholder="Soru metni" required/>
            <label htmlFor="correctAnswer">Doğru Cevap</label>
            <input type="text" name="correctAnswer" value={form.correctAnswer} onChange={handleChange}
                   placeholder="Doğru Cevap" required/>
            {[1, 2, 3, 4, 5].map((n) => (
                <React.Fragment key={n}>
                    <label htmlFor={`op_${n}`}>{`Seçenek ${n}`}</label>
                    <input type="text" name={`op_${n}`} value={form[`op_${n}`]} onChange={handleChange}
                           placeholder={`Seçenek ${n}`}/>
                </React.Fragment>
            ))}
            <label htmlFor="groupId">Soru Grubu</label>
            <select name="groupId" value={form.groupId} onChange={handleChange} required>
                <option value="">Soru Grubu Seçin</option>
                {groups.map((group) => (
                    <option key={group.id} value={group.id}>{group.groupName}</option>
                ))}
            </select>
            <button type="submit">Kaydet</button>
        </form>
    );
}

